import { render } from "./newsAndFAQ.vue?vue&type=template&id=a72a8484&scoped=true&ts=true"
import script from "./newsAndFAQ.vue?vue&type=script&setup=true&lang=ts"
export * from "./newsAndFAQ.vue?vue&type=script&setup=true&lang=ts"

import "./newsAndFAQ.vue?vue&type=style&index=0&id=a72a8484&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3191932516/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a72a8484"],['__file',"src/components/scan/newsinfo/newsAndFAQ.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a72a8484"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a72a8484', __exports__)) {
    console.log('reload')
    api.reload('a72a8484', __exports__)
  }
  
  module.hot.accept("./newsAndFAQ.vue?vue&type=template&id=a72a8484&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('a72a8484', render)
  })

}


export default __exports__